define('tooltips',['controller', 'lib/opentip-jquery'], function(controller) {
	Opentip.styles.wa5 = {
		"extends" : null,
		title : void 0,
		escapeTitle : true,
		escapeContent : false,
		className : "wa5-tooltip",
		stem : true,
		delay : 0.4,
		hideDelay : 0.2,
		timeTilHidingStarts: 0.2,
		fixed : false,
		showOn : "mouseover",
		hideTrigger : "trigger",
		hideTriggers : [],
		hideOn : null,
		removeElementsOnHide : true,
		offset : [ 0, 0 ],
		containInViewport : true,
		autoOffset : true,
		showEffect : "appear",
		hideEffect : "fade",
		showEffectDuration : 0.3,
		hideEffectDuration : 0.2,
		stemLength : 4,
		stemBase : 7,
		tipJoint : "bottom left",
		target : true,
		targetJoint : null,
		cache : true,
		ajax : false,
		ajaxMethod : "GET",
		ajaxErrorMessage : "Es gab ein Problem beim Herunterladen des Inhalts.",
		group : null,
		style : null,
		background : "#fff",
		backgroundGradientHorizontal : false,
		closeButtonOffset : [ 5, 5 ],
		closeButtonRadius : 7,
		closeButtonCrossSize : 4,
		closeButtonCrossColor : "#d2c35b",
		closeButtonCrossLineWidth : 1.5,
		closeButtonLinkOverscan : 6,
		borderRadius : 3,
		borderWidth : 1,
		borderColor : "rgb(189, 189, 189)",
		shadow : false,
		shadowBlur : 10,
		shadowOffset : [ 3, 3 ],
		shadowColor : "rgba(0, 0, 0, 0.1)"
	};
	
	Opentip.styles.preview = {
		"extends": "wa5",
		hideTrigger: null
	};

	Opentip.styles.notification = {
		"extends": "wa5",
		hideTriggers: [document, document],
		hideOn: ["keydown", "click"],
		showOn: "creation",
		target: true,
		timeTilHidingStarts: 3,
		tipJoint: "left",
        stemLength : 8,
        stemBase : 14
	};

	Opentip.styles.error = {
		"extends": "notification",
		background: "#990000",
		className: "error-tooltip"
	};

	Opentip.styles.success = {
		"extends": "notification",
		background: "#006600",
		className: "success-tooltip"
	};

	Opentip.styles.info = {
		"extends": "notification",
		className: "info-tooltip"
	};

	Opentip.defaultStyle = "wa5";

	Opentip.lastZIndex = 1010;

	function bindOnce(obj, event, handler) {
		obj.off(event, handler).on(event, handler);
	}

	/**
	 * A modified opentip that does not hide when the tooltip itself is hovered, but only when
	 * the mouse leaves both tooltip and trigger
	 * 
	 * Should be used with the "preview" style
	 */
	function HoverableOpentip() {
		Opentip.apply(this, arguments);
		this._boundMouseEnter = this._mouseEnter.bind(this);
		this._boundMouseLeave = this._mouseLeave.bind(this);
		this._boundMouseLeaveWhenHidden = this._mouseLeaveWhenHidden.bind(this);

		// this event listener cancels show timers
		this.triggerElement.on('mouseleave', this._boundMouseLeaveWhenHidden);
	}
	
	HoverableOpentip.prototype = Object.create(Opentip.prototype);
	
	HoverableOpentip.prototype.show = function() {
		Opentip.prototype.show.apply(this, arguments);
		
		this._mouseEntered = true;

		bindOnce(this.triggerElement, 'mouseenter', this._boundMouseEnter);
		bindOnce(this.triggerElement, 'mouseleave', this._boundMouseLeave);
		this.triggerElement.off('mouseleave', this._boundMouseLeaveWhenHidden);
		if (this.tooltipElement) {
			bindOnce(this.tooltipElement, 'mouseenter', this._boundMouseEnter);
			bindOnce(this.tooltipElement, 'mouseleave', this._boundMouseLeave);
		}
	};
	
	HoverableOpentip.prototype.hide = function() {
		Opentip.prototype.hide.apply(this, arguments);

		this.triggerElement.off('mouseenter', this._boundMouseEnter);
		this.triggerElement.off('mouseleave', this._boundMouseLeave);
		bindOnce(this.triggerElement, 'mouseleave', this._boundMouseLeaveWhenHidden);
		if (this.tooltipElement) {
			this.tooltipElement.off('mouseenter', this._boundMouseEnter);
			this.tooltipElement.off('mouseleave', this._boundMouseLeave);
		}
	};

	HoverableOpentip.prototype._mouseEnter = function() {
		this._mouseEntered = true;
		// hovering again, do not hide
		clearTimeout(this._hideTimeout);
	};

	HoverableOpentip.prototype._mouseLeave = function() {
		this._mouseEntered = false;
		this._setHideTimeout();
	};

	HoverableOpentip.prototype._setHideTimeout = function () {
		clearTimeout(this._hideTimeout);
		this._hideTimeout = setTimeout(function () {
			console.log('hiding');
			if (!this._mouseEntered)
				this.hide();
		}.bind(this), this.options.timeTilHidingStarts * 1000 /* s to ms */);
	};

	HoverableOpentip.prototype._mouseLeaveWhenHidden = function() {
		// cancel open timer if trigger area is left
		this.hide();
	};


	function TimedHoverableOpentip() {
		HoverableOpentip.apply(this, arguments)

	}

	TimedHoverableOpentip.prototype = Object.create(HoverableOpentip.prototype);

	TimedHoverableOpentip.prototype.show = function() {
		HoverableOpentip.prototype.show.apply(this, arguments);

		this._mouseEntered = false;
		this._setHideTimeout();
	};

	controller.on(function() {
		// remove old tooltips
		$('.opentip-container').remove();

		// only use opentip for custom tooltips like user previews
		$('[title][data-ot-style]').each(function() {
			var options = {};
			for (var optionName in Opentip.styles.standard) {
				var optionValue = $(this).data('ot-' + optionName);
				if (["yes","true","on"].indexOf(optionValue) >= 0)
					optionValue = true;
				else if (["no", "false", "off"].indexOf(optionValue) >= 0)
					optionValue = false;
				options[optionName] = optionValue;
			}
			
			var title = $(this).attr('title');
			$(this).removeAttr('title');
			if (options.style == 'preview')
				new HoverableOpentip(this, title, options);
			else
				new Opentip(this, title, options);
		});
	});

	return {
		HoverableOpentip: HoverableOpentip,
		Opentip: Opentip,
		TimedHoverableOpentip: TimedHoverableOpentip
	}
});

